import { useAtomValue } from 'jotai';
import { useSelector } from 'react-redux';
import { activeDashboardSelector } from '@store/tempDashboard/selectors';
import { pageMetaAtom } from '@src/atoms/pageMeta';

interface DrilldownMetaResult {
  useCaseKey: string;
  flowId?: number | string | undefined;
  frustrationSignalId?: number | string | undefined;
  eventId?: string | undefined;
  presetId?: string | undefined;
  widgetMeta: any;
}

// TODO: remove or update this after activeDashboardSelector is deprecated completely
// TODO: now have to keep widgetMeta from activeDashboardSelector to check, since ai-alert page is not using pageMetaAtom
export function useDrilldownMeta(): DrilldownMetaResult {
  const {
    useCaseKey: useCaseKeyFromAtom,
    flowPresetId,
    frustrationSignalPresetId,
    eventPresetId,
  } = useAtomValue(pageMetaAtom);

  const { usecaseKey: useCaseKeyFromStore, widgetMeta = {} } = useSelector(
    activeDashboardSelector,
  ) as any;
  const eventId = eventPresetId ?? (widgetMeta.eventId as string | undefined);
  const useCaseKey = useCaseKeyFromAtom ?? useCaseKeyFromStore;
  const flowId = flowPresetId ?? (widgetMeta.flowId as number | string | undefined);
  const frustrationSignalId =
    frustrationSignalPresetId ?? (widgetMeta.frustrationSignalId as string | undefined);

  // If it's not a flow or frustration signal, and we have a useCaseKey, it's a standard preset
  const presetId =
    !flowId && !frustrationSignalId && useCaseKey && useCaseKey !== 'nexa-drilldown'
      ? useCaseKey
      : undefined;

  return {
    useCaseKey,
    flowId,
    frustrationSignalId,
    presetId,
    eventId,
    widgetMeta,
  };
}
